import React from 'react'
import propTypes from "prop-types"
import { Skeleton, Typography } from '../'

export const Table = ({ tableRows, loader, isBorder }) => {
    return (
        <>
            <table className='w-full text-left font-thin'>
                <thead className='bg-primary-50 '>
                    <tr>
                        {!!tableRows?.headers?.length &&
                            tableRows?.headers?.map(header => <th key={header?.title} className='font-thin py-1'>
                                <Typography className={header?.style === "strong" ? "font-semibold" : ""} text={header?.title} variant="md" />
                            </th>)}
                    </tr>
                </thead>
                <tbody>
                    {loader ? <>{[1, 2, 3, 4, 5]?.map(e => <tr key={JSON.stringify(e)} className='h-fit'>
                        {!!tableRows?.headers?.length &&
                            tableRows?.headers?.map(header =>
                                <td key={JSON.stringify(header)} className=' py-1 h-fit'>
                                    <Skeleton length={1} className={"w-full h-6 rounded-sm"} />
                                </td>)}
                    </tr>)}
                    </> :
                        <>
                            {!!tableRows?.data?.length && tableRows?.data?.map((row, index) =>
                                <>
                                    <tr key={JSON.stringify(row)}>
                                        {tableRows?.headers?.map((column) => (
                                            <td key={JSON.stringify(column)}
                                                className={`${isBorder ? 'border-t border-secondary-200' : ''} py-2 w-fit h-fit ${row?.style === "thead" ? "bg-primary-50" : ""}`}>
                                                <Typography className={row?.style === "strong" ? "font-semibold" : ""} text={row?.[column?.key]} variant="sm" />
                                            </td>
                                        ))}
                                    </tr>
                                    <tr className='w-full h-fit'>
                                        <td className='w-fit h-fit pl-10' colSpan={12}>
                                            <table className='w-full text-left font-thin '>
                                                <thead className='bg-primary-50 h-fit'>
                                                    <tr className='font-thin py-1'>
                                                        {!!row?.children?.subHeader?.length && row?.children?.subHeader?.map((subHeader) => (
                                                            <th className='font-thin py-1' key={JSON.stringify(subHeader)}>
                                                                <Typography className={subHeader?.style === "strong" ? "font-semibold" : ""} text={subHeader?.title} variant="sm" />
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!!row?.children?.subData?.length && row?.children?.subData?.map((subRow) => (
                                                        <tr key={JSON.stringify(subRow)} className='border-b text-secondary-200 '>
                                                            {!!row?.children?.subHeader?.length && row?.children?.subHeader?.map((subHeader) => (
                                                                <td key={JSON.stringify(subHeader)} className={`${isBorder ? 'border-t border-b border-secondary-300' : ''} text-secondary-500 py-1 h-fit ${row?.style === "thead" ? "bg-primary-50" : ""}`}>
                                                                    <Typography className={row?.style === "strong" ? "font-normal" : ""} text={subRow?.[subHeader?.key]} variant="sm" />
                                                                </td>))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </>
                            )}
                        </>}
                </tbody>
            </table >
        </>
    )
}

Table.propTypes = {
    tableRows: propTypes.shape({
        headers: propTypes.arrayOf(
            propTypes.shape({
                id: propTypes.number,
                title: propTypes.string.isRequired,
                key: propTypes.string,
            })
        ).isRequired,
        data: propTypes.arrayOf(
            propTypes.shape({
                description: propTypes.string,
                id: propTypes.number,
                sac: propTypes.string,
                amount: propTypes.string,

            })
        )
    }),
    loader: propTypes.bool,
    isBorder: propTypes.bool,
}

Table.defaultProps = {
    tableRows: {
        headers: [
            { id: 0, title: "No.", key: 'no' },
            { id: 1, title: "Description of Product/Services", key: 'description' },
            { id: 2, title: "SAC", key: 'sac' },
            { id: 3, title: "Amount (INR)", key: 'amount' },

        ],
        data: [
            { no: 1, description: "First rended Items", id: 1, sac: "998313", amount: "114,764.19", children: { subHeader: [], subData: [] } },
            {
                no: 2, description: " greytHR greg Fees", id: 1, sac: "998313", amount: "114,764.19",
                children:
                {
                    subHeader: [
                        { id: 0, title: "SubHeader 1", key: 'description' },
                        { id: 1, title: "SubHeader 2", key: 'sac' },
                        { id: 2, title: "SubHeader 3", key: 'amount' }
                    ],
                    subData: [
                        { description: " Sub details", id: 22, sac: "43tt34t", amount: "efefe", },
                        { description: " Sub details", id: 22, sac: "43tt34t", amount: "efefe", },
                        { description: " Sub details", id: 22, sac: "43tt34t", amount: "efefe", },
                    ]
                }
            },
        ],
    },
    loader: false,
    isBorder: false
}